import React, { useEffect, useState } from 'react';
import Vimeo from '@u-wave/react-vimeo';
import '../styles/pages/Home.scss';
import { Icon } from '../components/icons/icons';
import { ReactComponent as CareerPathDiagram } from '../assets/svg/career-path-diagram.svg';
import IconHoverButton from "../components/IconHoverButton/IconHoverButton";
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';
import useWindowDimensions from '../hooks/windowDimensions';
import QuizComponent from '../components/quiz/QuizComponent';
import { useMsal } from '@azure/msal-react';
import { ROUTES } from '../route-constants';


const Home = () => {
    const { instance } = useMsal();
    const [account, setAccount] = useState(instance.getActiveAccount());
  const [isMobileClient, setIsMobileClient] = React.useState<boolean>(false);
  const { height, width } = useWindowDimensions();


  /* #region Use Effects */

  /* are we on a mobile device? */
  useEffect(() => {
    const finalValue = isMobile || width < 900;
    setIsMobileClient(finalValue);
  }, [width]);

  /* #endregion Use Effects */


  if (isMobileClient) {
    return (
      <div className='mobile'>
        <section className='bg-primary p-2'>
          <p className='m-0 clr-white p-b-1'>JMT is invested in the growth and progression of our employees.  The framework is set-up to promote career mobility, focusing on skills that are transferable between jobs, projects, and tasks. Watch the video to learn how to use this tool.</p>
          <Vimeo id="careerFrameworkVideo" video="https://player.vimeo.com/video/1065471926?h=cbfdb55678&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;dnt=1" className='home-page-video' responsive={true} />
          
          <div className='aln-center'>
            <CareerPathDiagram className='img-res m-t-2' height="400px" preserveAspectRatio="xMinYMid meet" />
          </div>
        </section>
        <section className='get-started-container p-2 aln-center'>
          <h2 className='fnt-wght-bold'>How to get started</h2>
          <p className='aln-justify'>All employees need to develop skills in the following essential areas: Core Business Skills and Discipline Specific Skills.</p>
          <div className='m-b-1'>
            <Link to={ROUTES.skillPath.core} className='btn-icon'>
              <Icon name='icon-btn-core-mobile' className='rounded-button clr-secondary' />
            </Link>
          </div>
          <div>
            <Link to={ROUTES.skillPath.discipline} className='btn-icon'>
              <Icon name='icon-btn-discipline-mobile' className='rounded-button clr-orange' />
            </Link>
          </div>
        </section>
        <section className='further-paths-container p-2 aln-center'>
          <h2 className='fnt-wght-bold'>Further Paths</h2>
          <p className='aln-justify'>Once you are competent in both JMT's Core Business Skills and your Discipline's skills, you can begin working towards skills in other career areas in the organization.</p>
          <p className='aln-justify'>Click on the buttons to explore the skills associated with each area of focus. Then, speak with your manager about current skill levels, identify goals, and begin working on skill development.</p>
          <div className='m-b-1'>
            <Link to={ROUTES.skillPath.projectManager} className='btn-icon'>
              <Icon name='icon-btn-pm-mobile' className='rounded-button clr-purple' />
            </Link>
          </div>
          <div className='m-b-1'>
            <Link to={ROUTES.skillPath.subjectMatterExpert} className='btn-icon m-b-1'>
              <Icon name='icon-btn-sme-mobile' className='rounded-button clr-yellow' />
            </Link>
          </div>
          <div>
          <Link to={ROUTES.skillPath.leaderManager} className='btn-icon'>
              <Icon name='icon-btn-lm-mobile' className='rounded-button clr-green' />
            </Link>
          </div>
        </section>
        <section>
          <div className='max-width'>
            <h2 className='fnt-wght-bold clr-primary aln-center'>Need help deciding where to start?</h2>
            {false && (<><p className='quiz-help'>Take this quick quiz to help suggest a path to begin exploring. Respond to each question with your initial instinct to help populate focus areas you may want to consider pursuing. These results are for informational purposes only and will not be saved.</p>
            <QuizComponent /></>)}
            <div className='dis-flex dis-flex-rows dis-flex-aln-center dis-flex-jst-center gap-4 m-t-2'>
              <Link to={ROUTES.faq} className='btn-icon aln-center'>
                <Icon name="icon-faq" className='help-icons icon-primary' />
                <span className='dis-block clr-primary fnt-sz-sml fnt-wght-bold m-t-1'>Take a look at the FAQ</span>
              </Link>
              <a href={"mailto:jmttrainer@jmt.com?subject=Career Framework Conversation Request&body=Hi L and D Team,%0D%0A%0D%0AI would like to request a conversation about the Career Framework.%0D%0A%0D%0AThank You,%0D%0A"+account?.name} className='btn-icon btn-outline-primary aln-center'>
                <Icon name="icon-chat" className='help-icons icon-primary' />
                <span className='dis-block clr-primary fnt-sz-sml fnt-wght-bold m-t-1'>Have a Career Conversation with L&D</span>
              </a>
            </div>
          </div>
        </section>
      </div>

    );
  } else
    return (
      <div className='desktop'>
        <section className='bg-primary p-4 p-t-1'>
          <div className='desktop-primary-container max-width'>
            <div>
              <div className='dis-inline-flex dis-flex-rows dis-flex-aln-center gap--75'>
                <h1 className='clr-white m-0'>Career Framework @</h1>
                <Icon name="icon-JMTLogo" className='icon-white logo' />
              </div>
              <p className='clr-white'>JMT is invested in the growth and progression of our employees.  The framework is set-up to promote career mobility, focusing on skills that are transferable between jobs, projects, and tasks. Watch the video to learn how to use this tool.</p>
              <Vimeo id="careerFrameworkVideo" video="https://player.vimeo.com/video/1065471926?h=cbfdb55678&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;dnt=1" className='home-page-video-desktop' responsive={true} />
            </div>
            <div>
              <CareerPathDiagram className='img-res m-t-2' height="400px" preserveAspectRatio="xMinYMid meet" />
            </div>
          </div>
        </section>
        <section className='further-paths-container'>
        </section>
        <section className='get-started-container'>
          <div className='desktop-started-further-grid max-width p-b-2 p-t-2'>
            <div className='border-right'>
              <div className='desktop-get-started-header-container'>
                <h2 className='fnt-wght-bold m-0 m-r-1 clr-primary'>How to get started</h2>
                <span className='dashed-line'></span>
                <span className='circle'></span>
              </div>
              <p className='p-r-2 aln-right'>All employees need to develop skills in the following essential areas: Core Business Skills and Discipline Specific Skills.</p>
            </div>
            <div className='p-l-2'>
              <div>
                <IconHoverButton isLink={true} linkURL={`#${ROUTES.skillPath.core}`} buttonClassName='btn-icon m-b-1 clr-secondary' buttonClassHoverName='' iconClassName='rounded-button' buttonOnClick={null} iconHoverClassName='rounded-button clr-secondary' iconName='icon-btn-core-up' iconHoverName='icon-btn-core-over' />
              </div>
              <div>
                <IconHoverButton isLink={true} linkURL={`#${ROUTES.skillPath.discipline}`} buttonClassName='btn-icon clr-orange' buttonClassHoverName='' iconClassName='rounded-button' buttonOnClick={null} iconHoverClassName='rounded-button clr-orange' iconName='icon-btn-discipline-up' iconHoverName='icon-btn-discipline-over' />
              </div>
            </div>
            <div className='aln-right border-right p-t-3 p-r-2'>
              <div>
                <IconHoverButton isLink={true} linkURL={`#${ROUTES.skillPath.projectManager}`} buttonClassName='btn-icon m-b-1 clr-purple' buttonClassHoverName='' iconClassName='rounded-button' buttonOnClick={null} iconHoverClassName='rounded-button clr-purple' iconName='icon-btn-pm-up' iconHoverName='icon-btn-pm-over' />
              </div>
              <div>
                <IconHoverButton isLink={true} linkURL={`#${ROUTES.skillPath.subjectMatterExpert}`} buttonClassName='btn-icon m-b-1 clr-yellow' buttonClassHoverName='' iconClassName='rounded-button' buttonOnClick={null} iconHoverClassName='rounded-button clr-yellow' iconName='icon-btn-sme-up' iconHoverName='icon-btn-sme-over' />
              </div>
              <div>
                <IconHoverButton isLink={true} linkURL={`#${ROUTES.skillPath.leaderManager}`} buttonClassName='btn-icon clr-green' buttonClassHoverName='' iconClassName='rounded-button' buttonOnClick={null} iconHoverClassName='rounded-button clr-green' iconName='icon-btn-lm-up' iconHoverName='icon-btn-lm-over' />
              </div>
            </div>
            <div className='p-t-3'>
              <div className='desktop-further-details-header-container'>
                <span className='circle'></span>
                <span className='dashed-line'></span>
                <h2 className='fnt-wght-bold clr-primary'>Further Paths</h2>
              </div>
              <p className='m-l-2'>Once you are competent in both JMT's Core Business Skills and your Discipline's skills, you can begin working towards skills in other career areas in the organization.</p>
              <p className='m-l-2'>Click on the buttons to explore the skills associated with each area of focus. Then, speak with your manager about current skill levels, identify goals, and begin working on skill development.</p>
            </div>
          </div>
        </section>
        
        <section className='desktop-quiz-container'>
          <div className='max-width'>
            <h2 className='fnt-wght-bold clr-primary aln-center'>Need help deciding where to start?</h2>
            {false && (<>
            <p className='quiz-help'>Take this quick quiz to help suggest a path to begin exploring. Respond to each question with your initial instinct to help populate focus areas you may want to consider pursuing. These results are for informational purposes only and will not be saved.</p>
            <QuizComponent />
            </>)}
            <div className='dis-flex dis-flex-rows dis-flex-aln-center dis-flex-jst-center gap-4 m-t-2'>
              <a href={`#${ROUTES.faq}`} className='btn-icon aln-center'>
                <Icon name="icon-faq" className='help-icons icon-primary' />
                <span className='dis-block clr-primary fnt-sz-sml fnt-wght-bold m-t-1'>Take a look at the FAQ</span>
              </a>
              <a href={"mailto:jmttrainer@jmt.com?subject=Career Framework Conversation Request&body=Hi L and D Team,%0D%0A%0D%0AI would like to request a conversation about the Career Framework.%0D%0A%0D%0AThank You,%0D%0A"+account?.name} className='btn-icon btn-outline-primary aln-center'>
                <Icon name="icon-chat" className='help-icons icon-primary' />
                <span className='dis-block clr-primary fnt-sz-sml fnt-wght-bold m-t-1'>Have a Career Conversation with L&D</span>
              </a>
            </div>
          </div>
        </section>
      </div>
    );
};

export default Home;